import SmallDetails from "components/SmallDetails/SmallDetails";
import moment from "moment";
import React from "react";
import { formatTimeDifference } from "utilities";

interface Props {
  value: number
  googleEstimatedDurationMinutes?: number
}

const getSublabel = (googleEstimatedDurationMinutes: number) => {
  if (!googleEstimatedDurationMinutes) {
    return null;
  }

  const durationGoogleFormatted = formatTimeDifference(moment.utc(), moment.utc().add(googleEstimatedDurationMinutes, "minute"));
  return ` ${durationGoogleFormatted} ${RESX.GroundTransport.AccordingToGoogle}`;
}

export const GroundTransportDuration = (props: Props) => {
  return <SmallDetails
    label={formatTimeDifference(moment.utc(), moment.utc().add(props.value, "minute"))}
    subLabel={getSublabel(props.googleEstimatedDurationMinutes)}
  />
}